import StepRoute from '../classes/step-route.class';
import RouteNames from '../constants/route-names';

const route = new StepRoute(
  RouteNames.AppointmentProperty,
  'property',
  () => import('@/views/steps/LocationStep.vue'),
);

route.requiresScheduleStep();
route.showSummarySidebar();

export default route.getRoute();
